import React, { useState, useEffect } from "react";
import { Admin, Resource, CustomRoutes } from "react-admin";
import { theme } from "./theme";
import BaseLayout from "./baseLayout/BaseLayout";
import SignIn from "./baseLayout/SignInNew";
import fdDataProvider from "./dataProvider/dataProvider";
import fdAuthProvider from "./authProvider/authProvider";
import Store from "./store/Store";
import APIProvider, { Config } from "./store/APIStore";
import "./App.css";
// import { createBrowserHistory as createHistory } from "history";
import { BrowserRouter } from 'react-router-dom'
import {customRoutes, customRoutesNoLayout} from "./customRoutes";
import { routePaths } from "./baseLayout/SidebarMenu";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DownTime from "./components/DownTime";
import apiCalls from "./Configs/config";
import PostHogPageView from "./PHPageView";

// const history = createHistory();

const App = () => {
  if (apiCalls) {
    return (
      <Store>
        <APIProvider config={apiCalls}>
          <BrowserRouter>
          <PostHogPageView />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Admin
              dataProvider={fdDataProvider as any}
              authProvider={fdAuthProvider}
              //@ts-ignore
              theme={theme}
              layout={BaseLayout}
              loginPage={SignIn}
              title="fielddrive Portal"
            >
              {/* default homepage */}
              <CustomRoutes>{customRoutes}</CustomRoutes>
              <CustomRoutes noLayout>{customRoutesNoLayout}</CustomRoutes>
              <Resource name={routePaths.ACTIVE_EVENTS} />
            </Admin>
            <DownTime />
            </LocalizationProvider>
          </BrowserRouter>
        </APIProvider>
      </Store>
    );
  }
  
  return <></>;
};

export default App;
